'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep2DetailsFormComponent = exports.addStep2DetailsFormComponent = {
    template: require('./add-step2-details-form.html'),
    bindings: {
        receiver: '<',
        delivery: '<',
        submitStep2: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function addStep2DetailsFormController(packagesService) {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.submitStep2Form = submitStep2Form;
        vm.onCancel = onCancel;
        vm.addOrderline = addOrderline;
        vm.deleteOrderline = deleteOrderline;
        vm.getPackageTypes = getPackageTypes;

        vm.packageTypes;
        vm.orderlines;
        vm.remark;
        vm.qty1;
        vm.qty2;
        vm.qty3;
        vm.qtyHcp;
        vm.signatureOfDelivery;

        vm.showError = false;

        function getPackageTypes() {
            packagesService.getPackageTypes().then(function (packageTypes) {
                vm.packageTypes = packageTypes;

            }, function (data) {

            });
        }

        vm.getPackageTypes();

        function init() {
            initForm();
        }

        function initForm() {

            if (vm.delivery) {
                vm.orderlines = vm.delivery.orderlines;
                vm.remark = vm.delivery.remark;
                vm.showError = false;
            } else {
                resetForm();
            }
        }

        function resetForm() {
            vm.orderlines = [];
            vm.remark = null;
            vm.showError = false;
            vm.addOrderline();
        }

        function addOrderline() {

            vm.orderlines.push({
                packageTypeCode: null,
                signatureRequired: false
            });
        }

        function deleteOrderline(index) {

            vm.orderlines.splice(index, 1);
        }

        function submitStep2Form() {

            var deliveryDetails = null;
            var error = false;

            // temp validate for demo
            error = false;

            if (error) {
                vm.showError = true;
            } else {
                vm.showError = false;
                deliveryDetails = {
                    remark: vm.remark,
                    orderlines: [{
                        signatureRequired: true,
                        packageType: {
                            code: "NORML",
                            name: "Standaard pakket",
                            description: "Kleiner dan een groene Febelco bak",
                            id: 1
                        }
                    }, {
                        signatureRequired: true,
                        packageType: {
                            code: "LARGE",
                            name: "Groot pakket",
                            description: "Groter dan een groene Febelco bak",
                            id: 2
                        }
                    }]
                };

                vm.submitStep2({ $event: deliveryDetails });
            }
        }

        function onCancel() {

            vm.cancel();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/add-step2-details-form.js
// module id = 851
// module chunks = 0